import { type IncludeKey, type Timeframe } from '~/services/studentData';

export const SPARK_RESTRICTED_TIMEFRAMES: Timeframe[] = ['30d', '90d', 'all'];

export const TIMEFRAME_OPTIONS: { label: string; value: Timeframe }[] = [
  { label: 'Last 24 hours', value: '24h' },
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 14 days', value: '14d' },
  { label: 'Last 30 days', value: '30d' },
  { label: 'Last 90 days', value: '90d' },
  { label: 'All time', value: 'all' },
];

const TIMEFRAME_LABELS: Record<Timeframe, string> = {
  '24h': 'Last 24 hours',
  '7d': 'Last 7 days',
  '14d': 'Last 14 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  all: 'All time',
};

export function getTimeframeLabel(timeframe: Timeframe, options: { case?: 'title' | 'sentence' } = {}): string {
  const label = TIMEFRAME_LABELS[timeframe];
  return options.case === 'sentence' ? label.toLowerCase() : label;
}

export const INCLUDE_LABELS: Record<IncludeKey, string> = {
  praises: 'Praises',
  warnings: 'Warnings',
  attendance: 'Absences',
};
